import { render, staticRenderFns } from "./bulk-create.vue?vue&type=template&id=75bc25f2&scoped=true&"
import script from "./bulk-create.vue?vue&type=script&lang=js&"
export * from "./bulk-create.vue?vue&type=script&lang=js&"
import style0 from "./bulk-create.vue?vue&type=style&index=0&id=75bc25f2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bc25f2",
  null
  
)

export default component.exports